import axios from "axios";
import Config from "config";
import { getHeaders } from "helpers/headers";
import { Dispatch } from "interfaces/dispatch";
import { ThunkActionCreator } from "interfaces/thunk";

// Fetch current user completion state for a store (bypasses user2stores filter)
export const fetchStoreCompletion: ThunkActionCreator<Promise<{ comments_review: number }>> =
  (storeId: string | number, projectId: string | number) =>
  (_dispatch: Dispatch) => {
    return axios
      .get(
        `${Config.API_SERVICE_URL}/api/store2projects/me/completion?storeId=${storeId}&projectId=${projectId}`,
        getHeaders()
      )
      .then((response) => response.data)
      .catch(() => ({ comments_review: 0 }));
  };

// Thunk Action Creator
export const toggleStoreCompletion: ThunkActionCreator<Promise<{ comments_review: number }>> =
  (storeId: string | number, projectId: string | number, completed: boolean) =>
  (_dispatch: Dispatch) => {
    return axios
      .patch(
        `${Config.API_SERVICE_URL}/api/store2projects/me/completion`,
        { storeId, projectId, completed },
        getHeaders()
      )
      .then((response) => response.data);
  };
